import { Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import type { SeriesReservationBannerData } from '@/common/services/seriesPage/types'
import { pluralize } from '@/utils/helpers'
import { toHumanReadableString } from '@/utils/time'

import { useUser } from '@/client/context/user'
import { useServerNow } from '@/client/hooks'
import { getSeriesUrl } from '@/client/services/url'

import SeriesReservationLinkCard from '../SeriesReservationLinkCard'

export default function SeriesReservationBanner({
  series,
}: {
  series: SeriesReservationBannerData
}): JSX.Element | null {
  const currentUser = useUser()
  const now = useServerNow()

  const seriesId = series.id

  const countReservations = series.viewer.reservedForOthersCount
  const firstExpireDate = series.viewer.reservedForOthersFirstExpiresAt

  const firstExpireDateTime = DateTime.fromISO(`${firstExpireDate}`)

  const referralLink = getSeriesUrl(seriesId, { referralUserId: currentUser.id })

  if (countReservations === 0) {
    return null
  }

  return (
    <SeriesReservationLinkCard
      referralLink={referralLink}
      header={() => (
        <Text color="fg">
          You have reserved <b>{pluralize(countReservations, 'additional spot')}</b> for this
          series. Copy this link to invite your{' '}
          {pluralize(countReservations, 'friend', { unitsOnly: true })} before their{' '}
          {countReservations === 1 ? 'spot expires' : 'spots expire'}{' '}
          <b>{toHumanReadableString(firstExpireDateTime.diff(now))}.</b>
        </Text>
      )}
    />
  )
}
